import { useLayoutEffect } from "react"
import { useLocation, useOutletContext } from "react-router-dom"
import { usePage } from "contexts/page-context"
import { Transition } from "components"
import Form from "./form"

// 230726 (permintaan user): edit order HO ber-status REJECTED — Form yang sama
// dengan create; mode edit dideteksi Form dari useParams (:id).
export default function Edit() {
  const { setTransition } = usePage()
  const { setTitle } = useOutletContext()
  const location = useLocation()

  useLayoutEffect(() => {
    setTransition(location.state?.transition)
    setTitle("Edit Order HO ke Customer")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Transition type="fade">
      <Form />
    </Transition>
  )
}
